module.exports = __webpack_public_path__ + "img/small-arrow.9600b1c9.svg";